import { Select } from "antd";
import PropTypes from "prop-types";

// TODO DEV-8551 `Option` is deprecated. Please use `options` instead.
// eslint-disable-next-line @typescript-eslint/no-deprecated
const { Option } = Select;

const ModelSelectOption = ({ option: { id, name }, fieldName }) => {
  return (
    <Option data-testid={`select-option-${fieldName}`} key={id} value={id}>
      {name}
    </Option>
  );
};

ModelSelectOption.propTypes = {
  option: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  fieldName: PropTypes.string,
};

export default ModelSelectOption;
